import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, ExternalLinkIcon, QuoteIcon, StarIcon } from 'lucide-react';
const REVIEW_SOURCE_URL = 'https://share.google/iVGpIdNttSw6arPIh';
const REVIEWS = [{
  quote: 'Quick response. Clear communication. Fair pricing. Friendly manner. Would use again!',
  name: 'Darol Klawetter',
  date: '3 weeks ago'
}, {
  quote: "Northface Irrigation's expertise is worth every penny they charge. We are very satisfied with their repair of our sprinkler system.",
  name: 'John Cordova',
  date: '2 months ago'
}, {
  quote: 'Unlike many services I have hired in the past, Raul and his brother arrived on time, even calling to let me know he was on his way. The unit was expertly installed, tested, and made to fit my schedule — not the contractor’s.',
  name: 'Glenn Rhinehart',
  date: '2 months ago'
}];
export function ReviewsSection() {
  return <section id="reviews" className="w-full bg-slate-50 py-16 sm:py-24" data-id="element-247" data-mp="nr13v9ndlhhy">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-248" data-mp="ntx3d2evge8i">
        <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-249" data-mp="3lx3f32vrpolq">
          <span className="inline-flex items-center gap-2 rounded-full border border-nfblue/15 bg-white px-3.5 py-1.5 text-xs font-bold uppercase tracking-[0.12em] text-nfblue shadow-sm" data-id="element-250" data-mp="3qqelj2wo43d4">
            <BadgeCheckIcon className="h-3.5 w-3.5 text-nfgreen-dark" data-id="element-251" data-mp="3gys76xp19o65" />
            Customer feedback
          </span>
          <h2 className="mt-5 font-display text-3xl font-extrabold text-slate-900 sm:text-4xl" data-id="element-252" data-mp="8l1mxkmg7229">
            Trusted by North Texas property owners
          </h2>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm" data-id="element-253" data-mp="3vopulbf529ua">
            <span className="font-display text-2xl font-extrabold text-slate-950" data-id="element-254" data-mp="4hn6isulkjoa">5.0</span>
            <div className="flex gap-0.5" aria-label="5.0 out of 5 stars" data-id="element-255" data-mp="2k9kft91qgkub">
              {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-256" data-mp="2p9yqyzymsawk" data-mpi={star} />)}
            </div>
            <span className="h-4 w-px bg-slate-300" aria-hidden="true" data-id="element-257" data-mp="urnin4sl5air" />
            <span className="font-semibold text-slate-600" data-id="element-258" data-mp="pu3vffdwtneo">176 Google reviews</span>
          </div>
          <p className="mt-3 max-w-2xl text-base leading-relaxed text-slate-600" data-id="element-259" data-mp="l1as8vy3an4p">
            Real feedback from customers who trusted Northface with their irrigation
            system, repairs, and property.
          </p>
        </div>

        <div className="mt-12" data-id="element-260" data-mp="bzl0fp0apm6e">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} className="mb-8 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-261" data-mp="72ujz0kkwokg">
            <div className="grid md:grid-cols-2" data-id="element-262" data-mp="1wghm2zjz9o1t">
              <div className="relative aspect-video bg-slate-900 md:aspect-auto" data-id="element-263" data-mp="1wf6jh329qmca">
                <video src="https://cdn.magicpatterns.com/uploads/iBTu5DVowJZimacUfvdKwz/cff95ef3-72e7-4826-ae1b-733ab8791f96.mov" controls playsInline preload="auto" className="absolute inset-0 z-10 h-full w-full object-cover" poster="https://cdn.magicpatterns.com/uploads/hafb5Qu2hSwizsFeVtjDyT/irrigation11.png" data-id="element-264" data-mp="1sgp7o67wknoj" />
              </div>
              <div className="flex flex-col justify-center p-8 sm:p-10" data-id="element-265" data-mp="2rfgf3o0mw5l6">
                <div className="flex items-center gap-2" data-id="element-266" data-mp="2wdhunyyupmrw">
                  <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-267" data-mp="2we1fbnfvyp9m">
                    {Array.from({
                    length: 5
                  }).map((_, star) => <StarIcon key={star} className="h-5 w-5 fill-amber-400 text-amber-400" data-id="element-268" data-mp="35ez819kvjacw" data-mpi={star} />)}
                  </div>
                  <span className="rounded-full bg-nfgreen/10 px-2.5 py-0.5 text-xs font-bold text-nfgreen-dark" data-id="element-269" data-mp="fom4winbtlto">
                    Featured Video Review
                  </span>
                </div>
                <QuoteIcon className="mt-6 h-8 w-8 text-nfblue/20" data-id="element-270" data-mp="j7l8p0bycw4e" />
                <blockquote className="mt-3 text-lg font-medium leading-relaxed text-slate-700" data-id="element-271" data-mp="e8rwrccbdd6c">
                  "Seeing the system run perfectly after the repair is the best proof of their work. They found the issue quickly, fixed it right, and now everything is getting the exact coverage it needs."
                </blockquote>
                <div className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5" data-id="element-272" data-mp="124cmiu8q6j12">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-nfblue/10 text-nfblue" data-id="element-273" data-mp="x6b6ki6liztt">
                    <BadgeCheckIcon className="h-5 w-5" data-id="element-274" data-mp="1bxtia3sfa87d" />
                  </div>
                  <div data-id="element-275" data-mp="16x5tzpvkw5gu">
                    <p className="font-bold text-slate-900" data-id="element-276" data-mp="16z05kdkyml89">Jackson Pfeffer</p>
                    <p className="text-xs text-slate-500" data-id="element-277" data-mp="1kwoqtmixvudu">Google review · System Repair</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          <div className="grid gap-5 md:grid-cols-3" data-id="element-278" data-mp="1zjner7il86nt">
            {REVIEWS.map((review, i) => <motion.figure key={review.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="relative flex min-h-[270px] flex-col rounded-2xl border border-slate-200 bg-white p-7 shadow-sm" data-id="element-279" data-mp="24gvznfv4eosr" data-mpi={i}>
              <div className="flex items-start justify-between gap-4" data-id="element-280" data-mp="1lknra36t9xt8">
                <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-281" data-mp="16vhx4tmtyxs7">
                  {Array.from({
                  length: 5
                }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-282" data-mp="xts27dtqpgpo" data-mpi={star} />)}
                </div>
                <div className="flex items-center gap-1.5 text-xs font-bold text-slate-500" data-id="element-283" data-mp="12slhnbsl7hsh">
                  <span className="flex h-5 w-5 items-center justify-center rounded-full bg-white text-xs font-extrabold text-[#4285F4] shadow-sm ring-1 ring-slate-100" data-id="element-284" data-mp="34hr1x79h6zdy">
                    G
                  </span>
                  Google
                </div>
              </div>
              <QuoteIcon className="mt-5 h-7 w-7 text-nfblue/20" data-id="element-285" data-mp="2upv13og08v61" />
              <blockquote className="mt-2 flex-1 text-[15px] leading-relaxed text-slate-700" data-id="element-286" data-mp="2qs73uequaqaz">
                “{review.quote}”
              </blockquote>
              <figcaption className="mt-5 flex items-center justify-between gap-3 border-t border-slate-100 pt-4 text-sm" data-id="element-287" data-mp="3ii1wak9zuw3v">
                <div data-id="element-288" data-mp="3ef5hz5rhlm5q">
                  <p className="font-bold text-slate-900" data-id="element-289" data-mp="3eencrjmujxlo">{review.name}</p>
                  <p className="mt-0.5 text-xs text-slate-500" data-id="element-290" data-mp="39g2c5j3onbwp">Google review · {review.date}</p>
                </div>
                <BadgeCheckIcon className="h-5 w-5 shrink-0 text-nfgreen" aria-label="Google review" data-id="element-291" data-mp="232mjpsiy9n04" />
              </figcaption>
            </motion.figure>)}
        </div>

        </div>

        <div className="mt-8 flex justify-center" data-id="element-292" data-mp="dkz6ov861pmc">
          <a href={REVIEW_SOURCE_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-5 py-3 text-sm font-bold text-slate-800 shadow-sm transition-colors hover:border-nfblue hover:text-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue focus:ring-offset-2" data-id="element-293" data-mp="ij0lh3yk72s0">
            View all Google reviews
            <ExternalLinkIcon className="h-4 w-4" data-id="element-294" data-mp="wa5moahks34g" />
          </a>
        </div>
        <p className="mt-3 text-center text-xs text-slate-500" data-id="element-295" data-mp="1187blc1omwnu">
          Read and verify every review directly on Northface Irrigation's Google Business Profile.
        </p>
      </div>
    </section>;
}